
import { Json } from "@/integrations/supabase/types";

export type PollStatus = 'draft' | 'live' | 'closed';

// Updated PollOption to include sentiment value and percentage
export interface PollOption {
  id: number;
  text: string;
  votes: number;
  sentiment?: number; // Value between -100 and 100, with positive being "agreement"
  percentage?: number; // Added percentage field for optimistic UI updates
  [key: string]: string | number | undefined; // Modified to allow undefined for sentiment and percentage
}

export interface PollQuestions {
  options: PollOption[];
  category?: string;
  total_votes?: number;
  linked_card_id?: string | null;
  closes_at?: string | null; // Add closes_at to the PollQuestions interface
}

export interface Poll {
  id: string;
  title: string;
  description: string;
  options: PollOption[];
  category: string;
  category_id?: string; // New field for DB category reference
  status: PollStatus;
  created_at: string;
  closes_at: string | null;
  country_code: string | null;
  constituency_code: string | null;
  total_votes: number;
  linked_card_id: string | null;
  poll_number: string | null; // Added poll_number field
  image_url?: string | null; // Added image_url field
  points_enabled?: boolean; // Add points_enabled property
  public_voting_allowed?: boolean; // Add public_voting_allowed property
  // Additional properties for the UI
  createdAt: string;
  updatedAt: string;
  endDate: string | null;
  createdBy: string | null;
  questions: PollQuestions;
  userHasVoted: boolean;
  countryCode: string | null;
  constituencyCode: string | null;
  categoryId: string | null;
  anonymous_allowed?: boolean; // Add support for anonymous voting
  anonymous_votes?: number; // Add support for anonymous vote count
  // Results properties
  results?: {
    totalVotes: number;
    topOption: string;
    agreePercentage?: number;
    selectedOptionId?: number; // Added this property to track user's selected option
  };
}

export interface PollResponse {
  poll_id: string;
  user_id: string;
  selected_option_id: number;
  created_at: string;
}

// Helper function for converting PollQuestions to Json
export const pollQuestionsToJson = (questions: PollQuestions): Json => {
  return questions as unknown as Json;
};
